export default __webpack_public_path__ + "static/media/caloToken.a05ca057.png";